import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

/**
 * Import all page components here
 */
import Rent from './Rent/rent';
import Home from './Home/home';
import Contact from './Contact/contact';
import About from './About/about';

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
const Routes = () => (
  <main>
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/home" component={Home} />
        <Route exact path="/rent" component={Rent} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/about" component={About} />
      </Switch>
    </BrowserRouter>
  </main>
);

export default Routes;
